export const getQffAuth = () => {
  if (window.qff_auth) {
    return window.qff_auth;
  }
};

export const addQffInitCompletedListener = (callback) => {
  getQffAuth().addEventListener('initCompleted', callback);
};

export const addQffLoginListener = (callback) => {
  getQffAuth().addEventListener('loginSuccess', callback);
};

export const addQffLogoutListener = (callback) => {
  getQffAuth().addEventListener('logoutSuccess', callback);
};

export const addQffOnProfileUpdateListener = (callback) => {
  document.addEventListener('onProfileUpdate', callback);
};

export const getQffUser = () => {
  const qffAuth = getQffAuth();

  return {
    title: qffAuth.getTitle(),
    firstName: qffAuth.getFirstName(),
    lastName: qffAuth.getLastName(),
    pointsBalance: Number(qffAuth.getPoints() || 0),
    membershipTier: qffAuth.getMembershipTier(),
  };
};

export const getAccessToken = () => {
  return getQffAuth().getAccessToken();
};

export const isAuthenticated = () => {
  return getQffAuth().isAuthenticated();
};

export const syncMemberProfile = () => {
  return getQffAuth().syncMemberProfile();
};

export const qffAuthInit = () => {
  const qffAuth = getQffAuth();

  if (qffAuth) {
    getQffAuth().init();
  }
};

export const qffAuthReload = () => {
  const qffAuth = getQffAuth();

  if (qffAuth) {
    qffAuth.reload();
  }
};
